// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error-container":"error-container___2z1bO"};